import React from 'react';

export default function Square() {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-square-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z" />
    </svg>
  );
}
